export enum LogLevel {
  info, warn, error, critical
}
